import { createContext, useContext } from 'react';

/**
 * @typedef {{
 *   workSites: any[],
 *   workSiteId: string,
 *   setWorkSiteId: (id: string) => void,
 *   bumpDashboardStats: () => void,
 *   toast: (v: string, m: string) => void,
 *   statsReloadNonce: number,
 *   showLocalPharmacy?: boolean,
 *   paths: Record<string, string>,
 *   copy: Record<string, unknown>,
 *   consultationEditPath: (id: number|string, opts?: { section?: string }) => string,
 *   filePath: (filterId?: string) => string,
 *   consultations?: any[],
 *   loading?: boolean,
 *   error?: string,
 *   loadQueue?: () => void,
 *   upsertConsultation?: (c: any) => boolean,
 *   syncAfterPatientReceived?: (c: any) => Promise<void>,
 *   counts?: Record<string, number>
 * }} NurseWorkspaceShape
 */

export const NurseWorkspaceContext = createContext(/** @type {NurseWorkspaceShape | null} */ (null));

export function useNurseWorkspace() {
  const v = useContext(NurseWorkspaceContext);
  if (!v) {
    throw new Error('useNurseWorkspace doit être utilisé dans NurseLayout ou MajorLayout.');
  }
  return v;
}
